/**
 * user (사용자) orval 래퍼
 */
import { customInstance } from "../custom-instance";
import { DEPARTMENT, POSITION } from "@erp/shared/types/user.types";
import { z } from "zod";
import { validateArrayWithSchema } from "@erp/shared/utils/https/zod-validation";
// ── 스키마 & 타입 ──
export const GetUsersResponseSchema = z
    .object({
    id: z.coerce.number(),
    userName: z.string(),
    givenName: z.string(),
    email: z.string(),
    officePhoneNumber: z.string().nullable(),
    internalNumber: z.string().nullable(),
    phoneNumber: z.string(),
    profileImageUrl: z.string().nullable(),
    position: z.object({
        id: z.coerce.number().nullable(),
        name: z.nativeEnum(POSITION).nullable(),
    }),
    department: z.object({
        id: z.coerce.number().nullable(),
        name: z.nativeEnum(DEPARTMENT).nullable(),
    }),
})
    .strict();
export const UserAuthorityGroupSchema = z
    .object({
    id: z.coerce.number(),
    name: z.string(),
    alias: z.string(),
})
    .strict();
export const GetUserAuthorityResponseSchema = z
    .object({
    ...GetUsersResponseSchema.shape,
    groups: z.array(UserAuthorityGroupSchema),
})
    .strict();
export const GetLoginUserResponseSchema = GetUsersResponseSchema.extend({
    groups: z.array(UserAuthorityGroupSchema),
});
export const GetAllowedMenuResponseSchema = z
    .object({
    id: z.coerce.number(),
    pageName: z.string(),
    pageAlias: z.string(),
    pageUrl: z.string(),
    groupId: z.coerce.number(),
})
    .strict();
export const GetAuthoritysResponseSchema = z.object({
    createdTime: z.string().datetime(),
    modifiedTime: z.string().datetime(),
    creater: z.coerce.number().nullable(),
    modifier: z.coerce.number().nullable(),
    deletedYn: z.number().int().min(0).max(1),
    id: z.coerce.number(),
    groupName: z.string(),
    groupAlias: z.string(),
});
// ── API 함수 ──
export async function getUsers(params) {
    return customInstance({
        url: "/user",
        method: "GET",
        params: {
            userName: params?.userId,
            excludeAdmin: params?.excludeAdmin,
            groupIds: params?.groupIds?.join(","),
        },
    });
}
export async function getLoginUser() {
    return customInstance({
        url: "/auth/user",
        method: "GET",
    });
}
export async function getAllowedMenu() {
    const data = await customInstance({
        url: "/user/allowed-menu",
        method: "GET",
    });
    validateArrayWithSchema(GetAllowedMenuResponseSchema, data);
    const filteredData = data.map((menu) => {
        return menu.pageUrl;
    });
    return filteredData.join(",");
}
export const getAuthoritys = async () => {
    const data = await customInstance({
        url: "/group",
        method: "GET",
    });
    return validateArrayWithSchema(GetAuthoritysResponseSchema, data);
};
export const getUserAuthority = async (params) => {
    const data = await customInstance({
        url: "/user/with-group",
        method: "GET",
        params,
    });
    return validateArrayWithSchema(GetUserAuthorityResponseSchema, data);
};
export const postUser = async (body) => {
    return customInstance({
        url: "/user",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: body,
    });
};
export const patchUser = async (userId, body) => {
    return customInstance({
        url: `/user/${userId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: body,
    });
};
export const deleteUser = async (userId) => {
    return customInstance({
        url: `/user/${userId}`,
        method: "DELETE",
    });
};
export const patchUserAuthority = async (userId, groupIds) => {
    return customInstance({
        url: `/user/group/${userId}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: { groupIds },
    });
};
// ── SDK 객체 ──
export const userApi = {
    getUsers,
    getLoginUser,
    getAllowedMenu,
    getAuthoritys,
    getUserAuthority,
    postUser,
    patchUser,
    deleteUser,
    patchUserAuthority,
};
